import { gaAddToCart } from "@/utils/gaEvent";
import { errorUtils } from "./error";
// import { criteoAddtoCart } from "@/utils/criteoEvent";
import { toast } from "@/components/global/Toast";
import viewcartApi from '@/service/modules/viewcartApi';
import { updateCartList } from "@/store/slices/cartListSlice";
import { AppDispatch } from "@/store/store";
import { useDispatch } from "react-redux";
import { matomoSetCustomDimension } from "./matomoEvent";

interface ParamsInterface {
  productID: string | number,
  qty: string | number,
  from?: number,
  location?: string,
  position?: number,
  pages?: number
}

interface BatchParams {
  productList: Array<{ pid: string | number, qty: string | number, from?: number }>,
  location?: string,
  position?: number,
  pages?: number
}

const useCartActions = () => {
  const dispatch: AppDispatch = useDispatch();

  const addToCart = async (event: any, parameter: ParamsInterface, callback?: Function) => {
    event.stopPropagation();
    const { productID, qty, from } = parameter;
    const params = { items: [{ pid: parseInt(`${productID}`), qty, from }] };
    await commonAddCart(params, parameter, dispatch, callback);
  }

  const batchAddToCart = async (event: any, parameter: BatchParams, callback?: Function) => {
    event.stopPropagation();
    const { productList } = parameter;
    const params = { items: productList };
    await commonAddCart(params, parameter, dispatch, callback);
  }

  return { addToCart, batchAddToCart };
}

const commonAddCart = async (params: any, queryData: any, dispatch: AppDispatch, callback?: Function,) => {
  try {
    const query = buildQuery(params.items, queryData);

    const addCartData = await viewcartApi.addToCart(params, query);

    const shopCartData = await viewcartApi.getList();
    const { list: { available } } = shopCartData.data
    // 更新状态购物车数据
    dispatch(updateCartList(shopCartData));

    const notice = (addCartData as any)?.notice
    if (
      notice
      && typeof notice === 'object'
      && !Array.isArray(notice)
      && Object.keys(notice).length > 0
      && shopCartData.data
      && typeof shopCartData.data === 'object'
      && !Array.isArray(shopCartData.data)
    ) {
      callback && callback({
        ...shopCartData,
        data: {
          ...shopCartData.data,
          notice
        }
      });
    } else {
      callback && callback(shopCartData);
    }

    if (params.items.length === 1) {
      handleAnalytics(params.items[0].pid, available, params.items[0].from);
    }
  } catch (error: unknown) {
    const message = errorUtils.getErrorMessage(error);
    toast.show(message);
    callback && callback("error");
  }
}

const buildQuery = (items: any[], queryData: any) => {
  if (items.length === 1) {
    const { location, position, pages } = queryData;
    if (location && (position === 0 || position)) {
      return `?pid=${items[0].pid}&location=${location}&position=${position || 0}&page=${pages || 1}`;
    }
  }
  return "";
}

const handleAnalytics = (
  productID: string | number,
  available: any[],
  from?: number
) => {
  if(available.length === 0) return;
  const goodsItem = available.find((v: any) => v.productID == productID);
  gaAddToCart("AUD", goodsItem.price, [{ ...goodsItem, quantity: 1 }]);

  matomoSetCustomDimension(23, JSON.stringify({
    productID,
    quantity: 1,
    source: Number(from) === 1 ? "add-on" : "normal",
  }))


  // const ScarabQueue: any = (window as any).ScarabQueue || [];
  // if (ScarabQueue) {
  //   const userEmail = localStorage.getItem('userEmail');
  //   if (userEmail) {
  //     ScarabQueue.push(['setEmail', userEmail]);
  //   }

  //   const scarabQueueCartData = available.map((item: any) => ({
  //     item: item.productID,
  //     price: Number(item.price),
  //     quantity: Number(item.quantity),
  //   }));

  //   ScarabQueue.push(['cart', scarabQueueCartData]);
  //   ScarabQueue.push(['go']);
  // }

  // const criteoParams: any = {
  //   id: goodsItem.productID,
  //   price: goodsItem.price,
  //   quantity: 1,
  // }
  // criteoAddtoCart([criteoParams])

}

export default useCartActions;
